import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-loading">
        <div className="font-nav text-[var(--sr-fire)] tracking-widest">ŁADOWANIE...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/logowanie" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/strefa" replace />;
  return children;
}
